export default {
  DATA: "@update_cities",
};
